
<div id="app">
  <notifications group="foo" position="bottom right" />
  <router-view />
</div>
